import axios, { AxiosRequestConfig, Method } from 'axios';
import { unwrapData } from '../utils/helperFn';

if (typeof window !== 'undefined') {
  sessionStorage.setItem('authToken', process.env.GATSBY_API_TOKEN || '');
}

const instance = axios.create({
  baseURL: process.env.GATSBY_API_URL,
  timeout: 50000,
  headers: {
    Authorization: `Bearer ${process.env.GATSBY_API_TOKEN}`,
  },
});
// 'Content-Type': 'application/json',

const callApi = async (
  method: Method,
  url: string,
  body?: any,
  options: AxiosRequestConfig = {}
) => {
  try {
    const config: AxiosRequestConfig = {
      url,
      method,
      ...options,
    };

    // Handle FormData (for file uploads)
    if (body instanceof FormData) {
      config.data = body;
      // Let browser set Content-Type with boundary
      config.headers = {
        ...config?.headers || {},
        ...options?.headers || {},
        'Content-Type': undefined,
      };
    } else if (body !== undefined) {
      config.data = body;
    }

    const response = await instance.request(config);

    return  response.hasOwnProperty('data') ? 
        {...response, data: unwrapData(response)} : 
        { "statusCode": 201, "successful": true, "data": unwrapData(response)};
  } catch (err) {
    console.log('API error', err);
    throw err;
  }
};

/**
 * Exported API wrapper
 */
const API = {
  get: (url: string, options = {}) => 
    callApi('get', url, undefined, options),
  post: (url: string, body: any, options = {}) =>
    callApi('post', url, body, options),
  put: (url: string, body: any, options = {}) =>
    callApi('put', url, body, options),
  patch: (url: string, body: any, options = {}) =>
    callApi('patch', url, body, options),
  delete: (url: string, options = {}) =>
    callApi('delete', url, undefined, options),
};

export default API;